import { Link } from '@appsumo/dorado-react';
import dayjs from 'dayjs';
import Image from 'next/image';

import { IDiscussionUserInfoProps } from '~/lib/discussions/types';
import VerifiedPuchasedBadge from '~/public/verified-purchased-badge.png';

function DiscussionUserInfo({
  username,
  avatar,
  isVerified,
  isPlus,
  isFounder,
  commentDate,
  userNamePadding = false,
}: Readonly<IDiscussionUserInfoProps>) {
  return (
    <div className="w-full" data-testid="discussion-user-info">
      {isFounder && (
        <div className="mb-2">
          <span className="rounded border-[0.5px] border-bolt p-1 text-xs font-semibold text-bolt">
            Founder
          </span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <Link
          className="shrink-0"
          href={`/profile/${username}/`}
          target="_blank"
        >
          <Image
            className="h-[50px] w-[50px] shrink-0 rounded-full object-cover"
            src={avatar}
            alt={username}
            height={50}
            width={50}
            loader={({ src }) =>
              avatar?.includes('gravatar') ? src : `${src}?w=50&h=50`
            }
          />
        </Link>
        <div className="space-y-0.5">
          <div className={`flex items-center ${userNamePadding ? 'pr-5' : ''}`}>
            <Link
              href={`/profile/${username}/`}
              target="_blank"
              className="truncate font-bold text-black-pearl"
            >
              {username}
            </Link>
            {isPlus && (
              <span
                data-testid="plus-badge"
                className="ml-2 rounded border-[0.5px] border-ready-red p-1 text-xs leading-none tracking-wider text-ready-red"
              >
                PLUS
              </span>
            )}
          </div>
          {(isVerified || commentDate) && (
            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              {isVerified && (
                <div className="flex shrink-0 items-center gap-1">
                  <Image
                    src={VerifiedPuchasedBadge}
                    alt="Verified Purchaser badge"
                    width={16}
                    height={16}
                  />
                  <p className="text-sm text-grace">Verified purchaser</p>
                </div>
              )}

              {commentDate && (
                <>
                  <span
                    className="h-1.5 w-1.5 shrink-0 rounded-full bg-gravel max-sm:hidden"
                    aria-hidden="true"
                  />
                  <span className="shrink-0 text-sm text-grace">
                    Posted {dayjs(commentDate).format('MMM D, YYYY')}
                  </span>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DiscussionUserInfo;
